(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jannela-autumn-clips"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jannela-autumn-banner')) {
    customElements.define('jannela-autumn-banner', class extends HTMLElement {
      connectedCallback() {
        if (this.active) return;
        this.active = true;
        this.controller = new AbortController();
        this.track = this.querySelector('.ja-autumn__track');
        this.viewport = this.querySelector('.ja-autumn__viewport');
        this.button = this.querySelector('.ja-autumn__pause');
        this.items = JSON.parse(this.querySelector('[data-autumn-products]').textContent);
        if (!this.items.length) return;
        this.speed = Number(this.dataset.speed) || 34;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.motion.matches;
        this.visible = false;
        this.offset = 0;
        this.next = 0;
        this.tick = this.tick.bind(this);
        this.refresh = this.refresh.bind(this);
        const options = { signal: this.controller.signal };
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.updateState();
        }, options);
        this.motion.addEventListener('change', event => {
          this.paused = event.matches;
          this.updateState();
        }, options);
        document.addEventListener('visibilitychange', () => this.updateState(), options);
        this.viewport.addEventListener('focusin', event => {
          if (event.target.matches(':focus-visible')) {
            this.keyboardFocus = true;
            this.updateState();
          }
        }, options);
        this.viewport.addEventListener('focusout', event => {
          if (!this.viewport.contains(event.relatedTarget)) {
            this.keyboardFocus = false;
            this.updateState();
          }
        }, options);
        this.resizeObserver = new ResizeObserver(this.refresh);
        this.resizeObserver.observe(this.viewport);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible && !this.feedStarted) {
            this.feedStarted = true;
            this.loadFeed();
          }
          this.updateState();
        }, { rootMargin: '250px' });
        this.intersectionObserver.observe(this);
        this.refresh();
        this.updateState();
      }

      disconnectedCallback() {
        this.active = false;
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }

      refresh() {
        if (!this.isConnected || !this.items.length) return;
        const style = getComputedStyle(this);
        const step = parseFloat(style.getPropertyValue('--ja-card')) + parseFloat(style.getPropertyValue('--ja-gap'));
        const count = Math.ceil(this.viewport.clientWidth / step);
        if (!count || (this.step === step && this.count === count)) return;
        const start = this.next || 0;
        this.step = step;
        this.count = count;
        this.offset = 0;
        this.track.replaceChildren();
        for (let position = 0; position < count + 2; position += 1) {
          const index = position === 0 ? start + count : position > count ? start : start + count - position;
          const card = document.createElement('a');
          card.className = 'ja-autumn__card';
          const imageWrapper = document.createElement('span');
          imageWrapper.className = 'ja-autumn__image';
          const image = document.createElement('img');
          image.className = 'ja-autumn__product-image';
          image.width = 540;
          image.height = 540;
          image.decoding = 'async';
          imageWrapper.append(image);
          const title = document.createElement('span');
          title.className = 'ja-autumn__title';
          card.append(imageWrapper, title);
          this.setCard(card, index);
          this.track.append(card);
        }
        this.next = start + count + 1;
        this.track.style.transform = `translate3d(${-step}px,0,0)`;
        this.classList.add('is-ready');
      }

      setCard(card, index) {
        const item = this.items[index % this.items.length];
        card.href = item.url;
        card.dataset.productId = String(item.id);
        card.dataset.catalogIndex = String(index % this.items.length);
        const image = card.querySelector('img');
        image.alt = item.title;
        image.sizes = '(max-width:749px) 120px,158px';
        image.srcset = `${item.small} 270w, ${item.image} 540w`;
        image.src = item.image;
        card.querySelector('.ja-autumn__title').textContent = item.title;
      }

      updateState() {
        const stopped = this.paused || this.keyboardFocus;
        this.dataset.paused = String(Boolean(stopped));
        this.dataset.outside = String(!this.visible || document.hidden);
        this.button.setAttribute('aria-pressed', String(this.paused));
        this.button.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        cancelAnimationFrame(this.frame);
        this.lastTime = null;
        if (!stopped && this.visible && !document.hidden) this.frame = requestAnimationFrame(this.tick);
      }

      tick(time) {
        if (!this.active || !this.step) return;
        if (this.lastTime !== null) this.offset += Math.min(time - this.lastTime, 80) * this.speed / 1000;
        this.lastTime = time;
        if (this.offset >= this.step) {
          this.offset -= this.step;
          const card = this.track.lastElementChild;
          this.setCard(card, this.next);
          this.next += 1;
          this.track.prepend(card);
        }
        this.track.style.transform = `translate3d(${this.offset - this.step}px,0,0)`;
        this.frame = requestAnimationFrame(this.tick);
      }

      async loadFeed() {
        try {
          const url = new URL(this.dataset.feedUrl, window.location.origin);
          url.searchParams.set('view', 'jannela-autumn-feed');
          const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          const products = [];
          const seen = new Set();
          let page = 1;
          let pages = 1;
          do {
            url.searchParams.set('page', String(page));
            let data;
            for (let attempt = 0; attempt < 3; attempt += 1) {
              try {
                const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal });
                if (!response.ok) throw new Error(`Product feed ${response.status}`);
                data = JSON.parse(await response.text());
                if (data.page !== page || !Array.isArray(data.products)) throw new Error('Invalid product feed');
                break;
              } catch (error) {
                if (error.name === 'AbortError' || attempt === 2) throw error;
                await new Promise(resolve => setTimeout(resolve, 700 * (attempt + 1)));
              }
            }
            pages = Number(data.pages) || 1;
            for (const product of data.products) {
              if (product.image && !seen.has(product.id)) {
                seen.add(product.id);
                products.push(product);
              }
            }
            page += 1;
          } while (page <= pages && this.isConnected);
          if (!this.isConnected || !products.length) return;
          this.items = products;
          this.dataset.loadedCount = String(products.length);
          this.dataset.feedComplete = 'true';
        } catch (error) {
          if (error.name !== 'AbortError') this.dataset.feedComplete = 'false';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jannela-launch-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jannela-launch-countdown')) {
  customElements.define('jannela-launch-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.interval) clearInterval(this.interval);
      this.interval = null;
      this.hidden = false;
      const end = Date.parse(this.dataset.end);
      const tick = () => {
        const total = Number.isFinite(end) ? Math.max(0, Math.ceil((end - Date.now()) / 1000)) : 0;
        const values = [Math.floor(total / 3600), Math.floor(total / 60) % 60, total % 60];
        ['hours', 'minutes', 'seconds'].forEach((unit, i) => {
          this.querySelector('[data-' + unit + ']').textContent = String(values[i]).padStart(2, '0');
        });
        if (total === 0 && this.interval) {
          clearInterval(this.interval);
          this.interval = null;
        }
        return total;
      };
      if (tick() > 0) this.interval = setInterval(tick, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
